export default "__VITE_ASSET__Ba4dJTPR__"